// Lo que dicen las tarjetas del asistente sobre este módulo, en los cuatro
// idiomas: `markets.assistant.decision.*`. El backend manda la clave y el texto
// en inglés (§16, backend/assistant.js); la tarjeta lo dice en el idioma de
// quien la lee. Es un contrato con ese fichero: una clave que cambia aquí
// cambia allí.

export default {
  es: {
    decision: {
      summary: 'Registrar la decisión «{title}»',
      action: 'Registrar una decisión de mercado',
      field: { title: 'Decisión', kind: 'Tipo', reason: 'Por qué', impact: 'Responde a', reviewAt: 'Volver a mirarlo el' },
      value: { noReview: 'Sin fecha' },
      where: 'Impacto de mercado',
      after: { closes: 'Se cerrará el impacto al que responde' },
      note: { noReview: 'Sin fecha para volver a mirarlo, nadie vuelve' },
      outcome: 'Decisión registrada: {title}',
    },
  },
  ca: {
    decision: {
      summary: 'Registrar la decisió «{title}»',
      action: 'Registrar una decisió de mercat',
      field: { title: 'Decisió', kind: 'Tipus', reason: 'Per què', impact: 'Respon a', reviewAt: 'Tornar-hi a mirar el' },
      value: { noReview: 'Sense data' },
      where: 'Impacte de mercat',
      after: { closes: 'Es tancarà l’impacte al qual respon' },
      note: { noReview: 'Sense data per tornar-hi a mirar, ningú no hi torna' },
      outcome: 'Decisió registrada: {title}',
    },
  },
  en: {
    decision: {
      summary: 'Record the decision “{title}”',
      action: 'Record a market decision',
      field: { title: 'Decision', kind: 'Kind', reason: 'Why', impact: 'Answers', reviewAt: 'Look at it again on' },
      value: { noReview: 'No date' },
      where: 'Market impact',
      after: { closes: 'The impact it answers will be closed' },
      note: { noReview: 'Without a date to look again, nobody does' },
      outcome: 'Decision recorded: {title}',
    },
  },
  fr: {
    decision: {
      summary: 'Enregistrer la décision « {title} »',
      action: 'Enregistrer une décision de marché',
      field: { title: 'Décision', kind: 'Type', reason: 'Pourquoi', impact: 'Répond à', reviewAt: 'À revoir le' },
      value: { noReview: 'Sans date' },
      where: 'Impact de marché',
      after: { closes: 'L’impact auquel elle répond sera clôturé' },
      note: { noReview: 'Sans date pour y revenir, personne n’y revient' },
      outcome: 'Décision enregistrée : {title}',
    },
  },
}
